import { mountVueComponent } from '@/lib/mount-vue-component';

export default function() {
  import('@/modules/payment-subscriptions/components/SubscriptionForm.vue').then(SubscriptionForm =>
    mountVueComponent('subscription-form', SubscriptionForm)
  );
}
